/**
 * Storage Initializer
 * 
 * Initializes localStorage with default project and site context on app startup.
 * This ensures map components have required context even on fresh browser sessions.
 */

import { getProjectsList, getProjectByName } from './mergeData';

export const initializeDefaultProjectContext = (): void => {
  try {
    // Check if selectedProject already exists
    const existingProject = localStorage.getItem('selectedProject');
    
    if (!existingProject) {
      // Get list of all projects
      const projectsList = getProjectsList();
      
      if (projectsList && projectsList.length > 0) {
        // Set first project as default - extract project_name from project object
        const defaultProjectName = projectsList[0].project_name;
        localStorage.setItem('selectedProject', JSON.stringify({ project_name: defaultProjectName }));
        
        // Get first project's details to extract first site
        const projectDetails = getProjectByName(defaultProjectName);
        
        if (projectDetails && projectDetails.sites && projectDetails.sites.length > 0) {
          // Initialize site keys with first available site from project
          const defaultSite = projectDetails.sites[0].site_name || 'Dwariknagar';
          
          localStorage.setItem('SelectedDropDownSite', JSON.stringify({ site_name: defaultSite }));
          localStorage.setItem('SelectedDropDownCarbonSite', JSON.stringify({ site_name: defaultSite }));
          localStorage.setItem('SelectedDropDownEnvSite', JSON.stringify({ site_name: defaultSite }));
        } else {
          // Fallback if no sites found
          localStorage.setItem('SelectedDropDownSite', JSON.stringify({ site_name: 'Dwariknagar' }));
          localStorage.setItem('SelectedDropDownCarbonSite', JSON.stringify({ site_name: 'Dwariknagar' }));
          localStorage.setItem('SelectedDropDownEnvSite', JSON.stringify({ site_name: 'Dwariknagar' }));
        }
      }
    }
  } catch (error) {
    console.warn('Failed to initialize storage context:', error);
    // Fallback: set Mangrove project with Dwariknagar as default site
    localStorage.setItem('selectedProject', JSON.stringify({ project_name: 'Mangrove' }));
    localStorage.setItem('SelectedDropDownSite', JSON.stringify({ site_name: 'Dwariknagar' }));
    localStorage.setItem('SelectedDropDownCarbonSite', JSON.stringify({ site_name: 'Dwariknagar' }));
    localStorage.setItem('SelectedDropDownEnvSite', JSON.stringify({ site_name: 'Dwariknagar' }));
  }
};
